import { render, staticRenderFns } from "./recordsTable.vue?vue&type=template&id=3861a59b&scoped=true"
import script from "./recordsTable.vue?vue&type=script&lang=js"
export * from "./recordsTable.vue?vue&type=script&lang=js"
import style0 from "./recordsTable.vue?vue&type=style&index=0&id=3861a59b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861a59b",
  null
  
)

export default component.exports